import { lazy, Suspense } from 'react';
import { Outlet, Route } from 'react-router-dom';

import ErrorBoundaryContainer from '../../components/ErrorBoundaryContainer';
import Loading from '../../components/Loading';

import accountRouter from '../account';

const ConcreteSensorDashboardComponent = lazy(
  () =>
    import(
      /* webpackChunkName: "dasconcrete-dashboard" */ '../../pages/dasconcrete-dashboard'
    ),
);

const dasconcreteDashboardRouter = (
  <Route path="dasconcrete-dashboard" element={<Outlet />}>
    <Route
      path=":projectId"
      element={
        <Suspense fallback={<Loading />}>
          <ErrorBoundaryContainer
            key="dasconcrete-dashboard"
            component={<ConcreteSensorDashboardComponent />}
          />
        </Suspense>
      }
    >
      {accountRouter()}
    </Route>
  </Route>
);

export default dasconcreteDashboardRouter;
